/**
 * It takes a size and returns a hash table object with methods to add, delete, and lookup items in the
 * hash table
 * @param size - The size of the hash table.
 */
const hashTable = function (size) {

    let storage = []

    /* A function that returns the storage array and the length of the storage array. */
    this.printStorage = () => {
        return { storage: storage, length: storage.length }
    }

    this.getStorage = () => {
        return storage
    }

    /* A hash function that takes a string and a max value and returns a hash value. */
    this.hash = (str, max) => {
        let hash = 0
        for (let i = 0; i < str.length; i++) {
            hash += str.charCodeAt(i)
        }
        return hash % max
    }

    /* Adding an item to the hash table. */
    this.addItem = (item) => {
        const node = this.hash(item[0], size)
        if (!storage[node]) {
            storage[node] = [item]
        } else {
            storage[node].push(item)
        }
    }

    /* Deleting an item from the hash table. */
    this.deleteItem = (key) => {
        const location = this.lookupItem(key, true)
        if (location) {
            const node = location.nodeIndex
            storage[node].splice(location.itemIndex, 1)
        }
    }

    /* Looking up the item in the hash table. */
    this.lookupItem = (key) => {
        const nodeIndex = this.hash(key, size)
        const node = storage[nodeIndex] || []
        for (let i = 0; i < node.length; i++) {
            if (node[i][0] === key) {
                // return returnIndex ? { nodeIndex: nodeIndex, itemIndex: i } : node[i]
                return node[i]
            }
        }
        return null
    }

    this.updateItem = (key, args) => {
        const nodeIndex = this.hash(key, size)
        let node = storage[nodeIndex] || []
        for (let i = 0; i < node.length; i++) {
            if (node[i][0] === key) {
                let item = node[i]
                item[2] = {...item[2], ...args}
                node[i] = item
                storage[nodeIndex] = node
            }
        }
        return null
    }

    /* Clearing the storage array. */
    this.purgeTable = (print) => {
        storage = []
        if (print) {
            this.printStorage()
        }
    }
}

export default hashTable